var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('Message',{ref:"message"}),_c('ConfirmLogout',{ref:"confirmLogout"}),_c('ConfirmDelete',{ref:"confirmDelete"}),_c('ConfirmLeave',{ref:"confirmLeave"}),_c('toolbar'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }